import { render, staticRenderFns } from "./AddNewSchool.vue?vue&type=template&id=5f4f9cef&"
import script from "./AddNewSchool.vue?vue&type=script&lang=js&"
export * from "./AddNewSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports